import updateProjectField from '../Services/updateProjectField';
import fetchProjects from '../Services/fetchProjects';

export default (id, field, value) => async (dispatch) => {

  await dispatch(updateProjectField(id, field, value));
  await dispatch(fetchProjects());
  
}